<template>
  <div>
    <div class="input-wrap">
      <label>标题</label>
      <el-input
        type="textarea"
        v-model="info.title"
        placeholder="请输入标题"
        class="input"
      ></el-input>
    </div>
    <div class="input-wrap">
      <label>描述</label>
      <el-input
        type="textarea"
        :rows="5"
        v-model="info.dec"
        placeholder="请输入描述"
        class="input"
      ></el-input>
    </div>
    <div class="input-wrap">
      <label>关键词</label>
      <el-input
        type="textarea"
        :rows="5"
        v-model="info.key_word"
        placeholder="请输入关键词"
        class="input"
      ></el-input>
    </div>
    <div class="btn-wrap">
      <el-button type="primary" class="confirmBtn" @click="confirmClick"
        >保存</el-button
      >
      <el-button @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getSettingSeoDetail, editSettingSeo } from "@/api/tdk";

export default {
  name: "tdkHandle",
  data() {
    return {
      info: {
        title: "",
        dec: "",
        key_word: "",
      },
      type: "add",
    };
  },
  mounted() {
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this._getSeoDetail(uuid);
    }
  },
  methods: {
    async confirmClick() {
      const { title, dec, key_word } = this.info;
      if (!title) {
        this.$message("标题不能为空");
        return;
      }
      if (!dec) {
        this.$message("描述不能为空");
        return;
      }
      if (!key_word) {
        this.$message("关键词不能为空");
        return;
      }
      const { status } = await editSettingSeo(this.info);
      if (status === 200) this.$router.go(-1);
    },
    cancelClick() {
      this.$router.go(-1);
    },
    async _getSeoDetail(id) {
      const { status, data } = await getSettingSeoDetail(id);
      if (status !== 200) return;
      this.info = data.result;
    },
  },
};
</script>

<style lang="less" scoped>
.input-wrap {
  margin-top: 30px;
  .sort_input {
    width: 300px;
  }
}
label {
  display: block;
  margin-bottom: 10px;
}
.img-wrap {
  margin-top: 30px;
}
.btn-wrap {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  .confirmBtn {
    margin-right: 50px;
  }
}
.input-wrap {
  width: 500px;
}
</style>
